import { useState, useEffect } from 'react';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import AudioRecorder from './components/AudioRecorder';
import CasesList from './components/CasesList';
import Categories from './components/Categories';
import Config from './components/Config';
import './App.css';

const DEFAULT_APP_NAME = 'Recording';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [username, setUsername] = useState(localStorage.getItem('username'));
  const [page, setPage] = useState('record');
  const [appName, setAppName] = useState(localStorage.getItem('appName') || DEFAULT_APP_NAME);

  useEffect(() => {
    document.title = appName;
  }, [appName]);

  useEffect(() => {
    fetch('/api/app-info')
      .then((r) => r.json())
      .then((data) => {
        if (data.appName) {
          setAppName(data.appName);
          localStorage.setItem('appName', data.appName);
        }
      })
      .catch(() => {});
  }, []);

  const handleLogin = (newToken, user) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('username', user);
    setToken(newToken);
    setUsername(user);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    setToken(null);
    setUsername(null);
    setPage('record');
  };

  const handleAppNameChange = (newName) => {
    setAppName(newName);
    localStorage.setItem('appName', newName);
  };

  if (!token) {
    return <Login onLogin={handleLogin} appName={appName} />;
  }

  return (
    <div className="app-layout">
      <Sidebar
        currentPage={page}
        onNavigate={setPage}
        username={username}
        onLogout={handleLogout}
        appName={appName}
      />
      <main className="main-content">
        {page === 'record' && <AudioRecorder token={token} />}
        {page === 'cases' && <CasesList token={token} />}
        {page === 'categories' && <Categories token={token} />}
        {page === 'config' && <Config token={token} appName={appName} onAppNameChange={handleAppNameChange} />}
      </main>
    </div>
  );
}

export default App;
